import apiService from './apiService';

const PREFIX = '/iti/chiffrage-site';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

async function requestFull(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

const chiffrageSiteService = {
  async getMeta() {
    return request(apiService.get(`${PREFIX}/meta`));
  },

  async getSession() {
    return request(apiService.get(`${PREFIX}/session`));
  },

  async startNewSession() {
    return request(apiService.post(`${PREFIX}/session/new`));
  },

  async listDossiers({ search = '', page = 1, limit = 100, scope = 'mine', commercial_id = '' } = {}) {
    const res = await requestFull(apiService.get(`${PREFIX}/dossiers`, {
      search,
      page,
      limit,
      scope,
      commercial_id: commercial_id || undefined,
    }));
    return { dossiers: res.data?.dossiers ?? [], pagination: res.pagination ?? {} };
  },

  async openDossier(id) {
    return request(apiService.post(`${PREFIX}/dossiers/${id}/open`));
  },

  async duplicateDossier(id) {
    return request(apiService.post(`${PREFIX}/dossiers/${id}/duplicate`));
  },

  async updateDossier(id, payload) {
    return request(apiService.put(`${PREFIX}/dossiers/${id}`, payload));
  },

  async deleteDossier(id) {
    return request(apiService.delete(`${PREFIX}/dossiers/${id}`));
  },

  async resetDossier(id) {
    return request(apiService.post(`${PREFIX}/dossiers/${id}/reset`));
  },

  async calculate(payload) {
    return request(apiService.post(`${PREFIX}/calculate`, payload));
  },

  async askAssistant(payload) {
    return request(apiService.post(`${PREFIX}/assistant`, payload, {}, { timeout: 60000 }));
  },

  async generateSlides(payload) {
    // Copie Drive + plusieurs batchUpdate Google Slides : délai généreux.
    return request(apiService.post(`${PREFIX}/generate-slides`, payload, {}, { timeout: 180000 }));
  },

  async pushDolibarr(payload) {
    // Plusieurs appels Dolibarr (création propale + lignes) : délai généreux.
    return request(apiService.post(`${PREFIX}/push-dolibarr`, payload, {}, { timeout: 120000 }));
  },

  async searchDolibarrThirdparties(search, { limit = 15, signal } = {}) {
    const data = await request(apiService.get(`${PREFIX}/dolibarr-thirdparties`, { search, limit }, { signal }));
    return data.thirdparties ?? [];
  },

  async getAdminConfig() {
    return request(apiService.get(`${PREFIX}/admin/config`));
  },

  async saveAdminConfig(payload) {
    return request(apiService.put(`${PREFIX}/admin/config`, payload));
  },
};

export default chiffrageSiteService;
